import React, {useRef, useState} from 'react'
import Item from './Item'

const DraggableList = ({data, onClick, onReorder}) => {
    const [order, setOrder] = useState(data.map(item => item.id))
    const container = useRef(null)
    const dragging = {}

    const getOrder = (arr, range) => {
        const list = [...arr]

        if (!range.length) {
            return list
        } else {
            return list.sort((a, b) => {
                let indexA = range.indexOf(a.id)
                let indexB = range.indexOf(b.id)

                return indexA - indexB
            })
        }
    }

    const onDragStart = (e, id) => {
        e.preventDefault()

        const body = document.querySelector('body')
        body.className = 'reorder'

        dragging.order = [...order]
        dragging.draggableId = id

        calculateDragParameters(e, id)
        calculateCoordinates(id)
        dragging.draggableEl = document.querySelector(`[data-list-item-id='${id}']`)

        document.addEventListener('mousemove', onDragMove)
        document.addEventListener('mouseup', onDragEnd)

        onDragMove(e)
    }

    const onDragMove = (e) => {
        let top = e.pageY - dragging.drag.relY - dragging.drag.top

        if (dragging.drag.min > top) {
            top = dragging.drag.min
        }

        if (dragging.drag.max < top) {
            top = dragging.drag.max
        }

        dragging.draggableEl.style.transform = `translate3d(0px, ${top}px, 0px)`

        const bottom = top + dragging.drag.cellHeight

        if (dragging.drag.elTop && top < dragging.drag.markerTop) {
            swapColumns(dragging.drag.elTop, false)
        } else if (dragging.drag.elBottom && bottom > dragging.drag.markerBottom) {
            swapColumns(dragging.drag.elBottom, true)
        }
    }

    const onDragEnd = (e) => {
        e.preventDefault()

        const body = document.querySelector('body')
        body.className = ''

        const els = document.querySelectorAll('[data-list-item-id]')
        els.forEach(item => item.style.transform = '')

        if (JSON.stringify(dragging.order) !== JSON.stringify(order)) {
            onReorder(dragging.order)
            setOrder(dragging.order)
        }

        dragging.order = null
        dragging.draggableId = null

        document.removeEventListener('mousemove', onDragMove)
        document.removeEventListener('mouseup', onDragEnd)
    }

    const calculateDragParameters = (e, draggableId) => {
        const parent = container.current.getBoundingClientRect()
        const cell = document.querySelector(`[data-list-item-id='${draggableId}']`).getBoundingClientRect()
        const min = parent.top - cell.top
        const max = parent.height - cell.height + min

        dragging.drag = {
            top: cell.top,
            min: min,
            max: max,
            relY: e.pageY - cell.top,
            cellHeight: cell.height
        }
    }

    const swapColumns = (targetId, direction) => {
        const trgtEls = document.querySelector(`[data-list-item-id='${targetId}']`)
        const transform = (dragging.drag.cellHeight) * (direction ? -1 : 1)

        if (trgtEls.style.transform) {
            trgtEls.style.transform = ''
        } else {
            trgtEls.style.transform = `translate3d(0px, ${transform}px, 0px)`
        }

        const targetIndex = dragging.order.indexOf(targetId)
        dragging.order[dragging.order.indexOf(dragging.draggableId)] = targetId
        dragging.order[targetIndex] = dragging.draggableId

        calculateCoordinates(dragging.draggableId)
    }

    const calculateCoordinates = (draggableId) => {
        if (draggableId) {
            const itemPosition = dragging.order.indexOf(draggableId)

            dragging.drag.elTop = null
            if (itemPosition) {
                dragging.drag.elTop = dragging.order[itemPosition - 1]
                dragging.drag.markerTop = getMarker(dragging.drag.elTop)
                if (!dragging.drag.markerTop === null) {
                    dragging.drag.elTop = null
                }
            }

            dragging.drag.elBottom = null
            if (itemPosition !== dragging.order.length - 1) {
                dragging.drag.elBottom = dragging.order[itemPosition + 1]
                dragging.drag.markerBottom = getMarker(dragging.drag.elBottom)
                if (dragging.drag.markerBottom === null) {
                    dragging.drag.elBottom = null
                }
            }
        }
    }

    const getMarker = (elId) => {
        const el = document.querySelector(`[data-list-item-id='${elId}']`)
        if (el) {
            const box = el.getBoundingClientRect()
            return box.top - dragging.drag.top + (box.height / 2)
        }
        return null
    }

    const list = getOrder(data, order)
    
    return (
        <div ref={container}>
            {list.map(item =>
                <Item
                    key={item.id}
                    id={item.id}
                    label={item.name}
                    handleClick={onClick}
                    handleDragStart={onDragStart}
                />
            )}
        </div>
    )
}

export default DraggableList
